// extracted by mini-css-extract-plugin
module.exports = {"button":"button_button__0y8j1","inverse":"button_inverse__iI5s5","small":"button_small__p9fo6","disabled":"button_disabled__Xw6lA"};